module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h6', [_vm._v("藥櫃清單")]), _c('vuetable', {
    ref: "vuetable",
    attrs: {
      "api-url": (_vm.server + "/api/system/?type=ADC"),
      "data-path": "results",
      "pagination-path": "",
      "fields": _vm.fields,
      "api-mode": true,
      "css": _vm.boostrapCss,
      "http-options": _vm.httpOptions,
      "detail-row-component": "adc-detail"
    },
    on: {
      "vuetable:cell-clicked": _vm.onCellClicked
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11fd2778","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/ADCManagement/ADCList.vue
// module id = 1393
// module chunks = 1